import type { FaixaDistancia } from "../../../services/faixasDistancia"

export type { FaixaDistancia }

export type AtribuirFaixasDistanciaModel = FaixaDistancia[]

export const AtribuirFaixasDistanciaInicial: AtribuirFaixasDistanciaModel = []

export const novaFaixaVazia = (tamanhoAtual: number): FaixaDistancia => ({
    id: -(tamanhoAtual + 1),
    distanciaMaxima: "",
    taxaEntrega: "",
    taxaEntregaNoturna: null,
    minimoEntregaGratis: null,
    taxaEntregador: null,
    versao: null,
})
